import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Commodity } from '../models/commodity';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CommodityQuery } from '../models/commodity-query';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Page } from '../interfaces/page';

@Injectable({ providedIn: 'root' })
export class CommodityService extends EntityCollectionServiceBase<Commodity> {

    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private http: HttpClient) {
        super('Commodity', serviceElementsFactory);
    }

    get(id: string): Observable<Commodity> {
        return this.entityMap$.pipe(
            map((entities) => entities[id]),
            switchMap((value) => value ? of(value) : this.getByKey(id))
        );
    }

    getMultiple(ids: string[]): Observable<Commodity[]> {
        return combineLatest(ids.map(id => this.get(id)));
    }

    query(query: CommodityQuery): Observable<Page<Commodity>> {
        let params = new HttpParams()
            .set('page', query.pageNumber?.toString() || 1)
            .set('itemsPerPage', query.itemsPerPage?.toString() || 25);
        if (query.sortColumn) {
            params = params.set('order[' + query.sortColumn + ']', query.sortDescending ? 'DESC' : 'ASC');
        }
        if (query.description) {
            params = params.set('description', query.description);
        }
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        return this.http.get<any>(`${environment.apiUrl}/commodity`, { headers, params }).pipe(
            map(response => ({ totalCount: response['hydra:totalItems'], page: response['hydra:member']}))
        );
    }

}
